module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h3', [_vm._v("Remediation Action: " + _vm._s(_vm.remediation_action.remediation_action_id))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.reTab
    }
  }, [_vm._v("Remediation Action")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.coTab
    }
  }, [_vm._v("Confirmation")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.reTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Remediation Action",
      "Index": "1"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Action Required")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                                        " + _vm._s(_vm.remediation_action.action) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Due Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                                        " + _vm._s(_vm.remediation_action.due_date) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Details of your compliance")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remediation_action.action_taken),
      expression: "remediation_action.action_taken"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.remediation_action.action_taken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remediation_action, "action_taken", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Any photographic evidence")])]), _vm._v(" "), (_vm.remediation_action) ? _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.remediation_action.remediationActionDocumentUrl) ? _c('filefield', {
    ref: "remediation_action_file",
    attrs: {
      "name": "remediation_action-file",
      "documentActionUrl": _vm.remediation_action.remediationActionDocumentUrl,
      "isRepeatable": true,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.remediationActionDocumentUploaded
    }
  }) : _vm._e()], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.coTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Confirmation",
      "Index": "2"
    }
  })], 1)]), _vm._v(" "), (_vm.canSaveSubmit) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary pull-right button-gap",
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary pull-right button-gap",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary pull-right button-gap",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit($event)
      }
    }
  })])])])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1230994"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/remediation_action.vue
// module id = 1035
// module chunks = 0